var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.855,
    height: 157.855,
    viewBox: "0 0 157.855 157.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact-online",
    transform: "matrix(-0.087, -0.996, 0.996, -0.087, -4052.47, 952.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_2",
    "data-name": "Differenzmenge 2",
    d: "M2.395,56.327a55.622,55.622,0,0,1-21-4.087,55.461,55.461,0,0,1-18.462-12.26A55.749,55.749,0,0,1-47.459,25.637,55.569,55.569,0,0,1-52.713,9.366a56.047,56.047,0,0,1-.117-16.932,55.6,55.6,0,0,1,5.02-16.328L-3.236,6.17,27.661,50.3A55.6,55.6,0,0,1,15.313,54.82,56.113,56.113,0,0,1,2.395,56.327ZM52.3,25.537h0L7.455-4.711-23.509-48.932A55.585,55.585,0,0,1-10.865-53.7,56.09,56.09,0,0,1,2.4-55.292a55.62,55.62,0,0,1,21,4.086,55.466,55.466,0,0,1,18.462,12.26,55.746,55.746,0,0,1,10.467,14.5A55.572,55.572,0,0,1,57.554-8a56.035,56.035,0,0,1-.009,17.1A55.566,55.566,0,0,1,52.3,25.536Z",
    transform: "translate(509.194 4189.661) rotate(50)",
    fill: "#ebeeeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 39.594,
    cy: 39.594,
    r: 39.594,
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 474.379, 4148.904)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-laptop",
    transform: "translate(530.562 4172.089) rotate(95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_197",
    "data-name": "Pfad 197",
    d: "M37.321,24.59H2.113V2.353A1.854,1.854,0,0,1,3.966.5h31.5a1.854,1.854,0,0,1,1.853,1.853Z",
    transform: "translate(1.376)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_198",
    "data-name": "Pfad 198",
    d: "M38.7,13.5H3.489L.6,22.18a1.853,1.853,0,0,0,1.757,2.439h37.48A1.853,1.853,0,0,0,41.59,22.18Z",
    transform: "translate(0 11.09)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_18",
    "data-name": "Linie 18",
    x2: 5.559,
    transform: "translate(18.314 32.002)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactOnline);
export default __webpack_public_path__ + "static/media/contact-online.8f300829859f4b3ffb711923d87747af.svg";
export { ForwardRef as ReactComponent };